import type { CSSProperties } from "react"
import { useTheme } from "@/contexts/ThemeContext"
import { toast, Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { colorScheme } = useTheme()

  return (
    <Sonner
      theme={colorScheme}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--color-background)",
          "--normal-text": "var(--color-foreground)",
          "--normal-border": "var(--color-border)",
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster, toast }
